import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-carousel',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-carousel works!</p> `,
  styles: ``,
})
export class CpCarouselComponent {}
